module.exports = __webpack_public_path__ + "static/media/history-white.d985667e.svg";